module.exports = __webpack_public_path__ + "img/OMART_MOBILE.8e12f3c5.svg";